import { Navigate, useNavigate } from "react-router-dom";
import { ArrowLeft, UserCog } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { displayName } from "@/lib/format";
import BusesPage from "@/pages/admin/BusesPage";

export default function OfficerBusStatusPage() {
  const { user } = useAuth();
  const nav = useNavigate();
  if (user && !["admin", "officer", "corporate_admin"].includes(user.role)) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen bg-slate-50" data-testid="officer-bus-status-page">
      <header className="sticky top-0 z-30 flex items-center justify-between gap-3 border-b border-slate-200 bg-white px-6 py-3">
        <button onClick={() => nav("/kiosk")} data-testid="bus-status-back-btn"
          className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 transition">
          <ArrowLeft className="h-4 w-4" /> Back to kiosk
        </button>
        <div className="flex items-center gap-2 rounded-full bg-emerald-50 px-4 py-1.5 border border-emerald-200 text-sm">
          <UserCog className="h-4 w-4 text-emerald-700" />
          <span className="text-emerald-700 font-medium">On duty:</span>
          <span className="font-semibold text-slate-900">{displayName(user?.name)}</span>
        </div>
      </header>
      <div className="[&>div]:max-w-6xl [&>div]:mx-auto"><BusesPage /></div>
    </div>
  );
}
